<div aria-label="CUE Solution license is invalid">
  <h2>{{ 'navigation.invalidCueLicence' | transloco }}</h2>

  <img src="assets/images/navigation/background.png" alt="CUE Solution license is invalid" />
</div>
